import { ButtonOptionsV2, ButtonV2, InputDateRHFV2, InputRHFV2, MyModal } from "../../Atoms";
import { StatusAgendamentoEnum } from "../../../enums/statusAgendamento";
import { reverseToBrDate } from "../../../utils/dateTransform";
import { removeUnderscore } from "../../../utils/removeUnderscore";
import { maskCnpj, maskCpf } from "../../../utils/masks";
import { useFormScheduleDetailV2 } from "./useFormScheduleDetailV2";

export const FormScheduleDetailV2 = () => {
  const {
    agendamento,
    modalReembolso,
    setModalReembolso,
    confirmarPagamento,
    retornarStatusIniciado,
    confirmarReembolso,
    downloadLaudo,
    acessarFatura,
    onFinalize,
  } = useFormScheduleDetailV2();

  const localRealizacao = agendamento?.loja?.endereco
    ? `${agendamento?.loja?.endereco?.logradouro} - ${agendamento?.loja?.endereco?.bairro}, ${agendamento?.loja?.endereco?.cidade} - ${agendamento?.loja?.endereco?.uf}`
    : agendamento?.atendimentoDomiciliar?.endereco
      ? `${agendamento?.atendimentoDomiciliar?.endereco?.logradouro}, ${
          agendamento?.atendimentoDomiciliar?.endereco?.numero
            ? `${agendamento?.atendimentoDomiciliar?.endereco?.numero},`
            : ""
        } ${
          agendamento?.atendimentoDomiciliar?.endereco?.complemento
            ? `${agendamento?.atendimentoDomiciliar?.endereco?.complemento}`
            : ""
        } - ${agendamento?.atendimentoDomiciliar?.endereco?.bairro}, ${
          agendamento?.atendimentoDomiciliar?.endereco?.cidade
        }/${agendamento?.atendimentoDomiciliar?.endereco?.uf}`
      : "---";

  const cpfCnpj =
    agendamento?.cliente?.cpfCnpj?.length > 11
      ? maskCnpj(agendamento?.cliente?.cpfCnpj)
      : maskCpf(agendamento?.cliente?.cpfCnpj);

  return (
    <div className="flex w-full flex-col gap-8">
      <div className="flex items-center justify-end gap-3">
        {agendamento?.status === StatusAgendamentoEnum.FINALIZADO && (
          <ButtonV2 type="button" onClick={downloadLaudo}>
            <img src="/assets/svgs/icon-down-white.svg" alt="icone download" />
            Baixar Laudo
          </ButtonV2>
        )}

        {agendamento && (
          <ButtonOptionsV2
            agendamento={agendamento}
            handleConfirmPayment={confirmarPagamento}
            handleReturnStatus={retornarStatusIniciado}
            handlePix={acessarFatura}
            handleConfirmRefund={setModalReembolso}
            onFinalize={onFinalize}
          />
        )}
      </div>

      <div className="grid grid-cols-1 gap-x-[15px] gap-y-6 rounded-[24px] border border-solid border-[#e5e5ea] bg-white p-8 shadow-[0px_8px_24px_0px_rgba(0,0,0,0.078)] md:grid-cols-12">
        <div className="col-span-1 md:col-span-6">
          <InputRHFV2
            id="status"
            label="Status"
            readOnly
            value={removeUnderscore(agendamento?.status)}
          />
        </div>

        <div className="col-span-1 md:col-span-3">
          <InputRHFV2
            id="data"
            label="Data"
            readOnly
            value={reverseToBrDate(agendamento?.diaAgendado)}
          />
        </div>

        <div className="col-span-1 md:col-span-3">
          <InputRHFV2
            id="horario"
            label="Horário"
            readOnly
            value={agendamento?.horaAgendada}
          />
        </div>

        <div className="col-span-1 md:col-span-4">
          <InputRHFV2
            id="cliente"
            label="Cliente"
            readOnly
            value={agendamento?.cliente?.nome || "---"}
          />
        </div>

        <div className="col-span-1 md:col-span-4">
          <InputRHFV2
            id="cpfCnpj"
            label="CPF/CNPJ"
            readOnly
            value={cpfCnpj}
          />
        </div>

        <div className="col-span-1 md:col-span-4">
          <InputRHFV2
            id="telefone"
            label="Telefone"
            readOnly
            value={agendamento?.cliente?.telefone || "---"}
          />
        </div>

        <div className="col-span-1 md:col-span-6">
          <InputRHFV2
            id="email"
            label="E-mail"
            readOnly
            value={agendamento?.cliente?.email || "---"}
          />
        </div>

        <div className="col-span-1 md:col-span-6">
          <InputRHFV2
            id="modeloCarro"
            label="Modelo do carro"
            readOnly
            value={agendamento?.veiculo?.modelo || "---"}
          />
        </div>

        <div className="col-span-1 md:col-span-6">
          <InputRHFV2
            id="placa"
            label="Placa"
            readOnly
            value={agendamento?.veiculo?.placa || "---"}
          />
        </div>

        <div className="col-span-1 md:col-span-6">
          <InputRHFV2
            id="renavam"
            label="Renavam"
            readOnly
            value={agendamento?.veiculo?.renavam || "---"}
          />
        </div>

        <div className="col-span-1 md:col-span-6">
          <InputRHFV2
            id="chassi"
            label="Chassi"
            readOnly
            value={agendamento?.veiculo?.chassi || "---"}
          />
        </div>

        <div className="col-span-1 md:col-span-6">
          <InputRHFV2
            id="servico"
            label="Serviço"
            readOnly
            value={agendamento?.servico?.nome || "---"}
          />
        </div>

        <div className="col-span-1 md:col-span-12">
          <InputRHFV2
            id="localRealizacao"
            label="Local de Realização do Serviço"
            readOnly
            value={localRealizacao}
          />
        </div>
      </div>

      <MyModal
        isOpen={modalReembolso?.isOPen}
        onRequestClose={() => setModalReembolso({ isOPen: false, date: null })}
      >
        <form
          onSubmit={confirmarReembolso}
          className="flex w-full max-w-[90%] flex-col gap-6 p-4 md:min-w-[420px] md:max-w-[420px] md:p-6"
        >
          <p>
            Informe a data do <strong>reembolso</strong>.
          </p>

          <InputDateRHFV2
            id="dataReembolso"
            label="Data"
            selected={modalReembolso?.date}
            onChange={(date) =>
              setModalReembolso((prev) => ({
                ...prev,
                date: date as Date,
              }))
            }
          />

          <div className="flex items-center justify-end gap-4">
            <ButtonV2
              variant="text"
              type="button"
              onClick={() => setModalReembolso({ isOPen: false, date: null })}
            >
              Cancelar
            </ButtonV2>
            <ButtonV2 type="submit">Confirmar</ButtonV2>
          </div>
        </form>
      </MyModal>
    </div>
  );
};
